"use client";
import { useMemo } from "react";
import { Debug, type UserInfos } from "@bytel/logger-core";

import { PrismeProviderBase } from "@bytel/logger-web/react";
import { WebPrismeLogger } from "@bytel/logger-web";
import { NextPrismeConfig } from "./typings";

const debug = Debug("logger:next-client");

export const PrismeProvider: React.FC<{
  children: React.ReactNode;
  userInfos: UserInfos;
  trackerId?: string;
  config: NextPrismeConfig;
}> = ({ children, userInfos, trackerId, config }) => {
  const logger = useMemo(() => {
    const universalConfig = {
      ...config,
      // for security reason we dont accept serverUrlEndpoint as config
      // so it cannot appear client side
      urlEndpoint:
        process.env.LOG_SERVER_URL_ENPOINT ?? config.clientUrlEndpoint,
      application:
        typeof window !== "undefined"
          ? config.applicationClientName
          : config.applicationServerName,
      userInfoProvider: (): UserInfos => userInfos,
      ...(trackerId && { trackerIdProvider: (): string => trackerId }),
    };
    debug(
      "PrismeProvider > side = ",
      typeof window === "undefined" ? "server" : "client",
    );
    debug(
      "PrismeProvider > creating new WebPrismeLogger with config",
      universalConfig,
    );
    return new WebPrismeLogger(universalConfig);
  }, [config.clientUrlEndpoint]);

  return <PrismeProviderBase logger={logger}>{children}</PrismeProviderBase>;
};

export { usePrismeLogger } from "@bytel/logger-web/react";
